export default __webpack_public_path__ + "media/images/left_rear_facing.png";